import { ApiBase, ApiResponse } from 'types';
import {
  Campaign,
  SaveCampaignMatchingRequest,
  SaveCampaignRequest,
  UpdateCampaignMatchingRequest,
  CampaignMatchingFilterRequest,
  BulkCampaignMatchingResult,
} from 'types/campaign.types';

const BASE_URL = 'campaign';
export class CampaignApi extends ApiBase {
  public async getCampaignList(): Promise<ApiResponse<{ campaigns: Campaign[] }>> {
    const response = await this.apiClient.get(`${BASE_URL}/list`);

    return response.data;
  }

  public async getCampaignDetail(campaignId: number): Promise<ApiResponse<Campaign>> {
    const response = await this.apiClient.get(`${BASE_URL}/detail/${campaignId}`);
    return response.data;
  }

  public async saveCampaign(request: SaveCampaignRequest): Promise<ApiResponse<void>> {
    const response = await this.apiClient.post(`${BASE_URL}/save`, request);
    return response.data;
  }

  public async deleteCampaign(campaignId: number): Promise<ApiResponse<void>> {
    const response = await this.apiClient.put(`${BASE_URL}/set-passive/${campaignId}`);
    return response.data;
  }

  async matchCampaignToUser(request: SaveCampaignMatchingRequest): Promise<any> {
    const response = await this.apiClient.post(`${BASE_URL}/match-campaign`, request);
    return response.data;
  }

  async checkCampaign(phoneNumber: string): Promise<any> {
    const response = await this.apiClient.get(`${BASE_URL}/check?phoneNumber=${phoneNumber}`);
    return response.data;
  }

  async getCampaignListForReport(): Promise<any> {
    const response = await this.apiClient.get(`${BASE_URL}/list-report`);
    return response.data;
  }

  async getCampaignUsedDetailForReport(campaignId: number): Promise<any> {
    const response = await this.apiClient.get(`${BASE_URL}/used-detail-report/${campaignId}`);
    return response.data;
  }

  async bulkMatchCampaigns(file: File): Promise<ApiResponse<BulkCampaignMatchingResult[]>> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await this.apiClient.post(`${BASE_URL}/bulk-match-campaigns`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async getCampaignMatchingList(filters?: CampaignMatchingFilterRequest): Promise<ApiResponse<any[]>> {
    const params = new URLSearchParams();
    if (filters?.searchTerm) {
      params.append('searchTerm', filters.searchTerm);
    }
    if (filters?.campaignId) {
      params.append('campaignId', filters.campaignId.toString());
    }
    if (filters?.groupType) {
      params.append('groupType', filters.groupType.toString());
    }

    const queryString = params.toString();
    const url = queryString ? `${BASE_URL}/matching-list?${queryString}` : `${BASE_URL}/matching-list`;

    const response = await this.apiClient.get(url);
    return response.data;
  }

  async deleteCampaignMatching(id: number): Promise<ApiResponse<{ success: boolean }>> {
    const response = await this.apiClient.put(`${BASE_URL}/matching/${id}/delete`);
    return response.data;
  }

  async updateCampaignMatching(request: UpdateCampaignMatchingRequest): Promise<ApiResponse<{ success: boolean }>> {
    const response = await this.apiClient.put(`${BASE_URL}/matching-update`, request);
    return response.data;
  }

  async exportCampaignMatchingList(filters?: CampaignMatchingFilterRequest): Promise<Blob> {
    const response = await this.apiClient.post(`${BASE_URL}/export-matching-list`, filters || {}, {
      responseType: 'blob',
    });
    return response.data;
  }
}
